import styled from '@emotion/styled';
import WhiteLogoImage from 'images/carro-md-white-extended.png';
import BlackLogoImage from 'images/carro-md-black-extended.svg';
import BackgroundImage from 'images/login-background.png';
import OnboardingBackgroundImageSVG from 'images/onboarding-background.svg';
import type { ComponentProps } from 'react';

interface LayoutProps {
  hasBlueBackground?: boolean;
  hasOnboardingBackground?: boolean;
}

const Root = styled.div<LayoutProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-color: ${({ theme }) => theme.color.bodyBackground};

  ${({ hasBlueBackground = true }) =>
    hasBlueBackground && `background-image: url(${BackgroundImage});`}

  ${({ hasOnboardingBackground = false }) =>
    hasOnboardingBackground && `background-image: url(${OnboardingBackgroundImageSVG});`}
`;

interface ContentProps {
  $width?: string;
  $maxWidth?: string;
}

const Content = styled.div<ContentProps>`
  width: ${({ $width = 'auto' }) => $width};
  max-width: ${({ $maxWidth }) => $maxWidth};
`;

const Logo = styled((props: Omit<ComponentProps<'img'>, 'src' | 'alt'>) => (
  <img {...props} src={WhiteLogoImage} alt="Carro Logo" />
))`
  width: 400px;
`;

const BlackLogo = styled((props: Omit<ComponentProps<'img'>, 'src' | 'alt'>) => (
  <img {...props} src={BlackLogoImage} alt="Carro Logo" />
))`
  width: 400px;
`;

/**
 * Layout is a basic layout component that can be used to wrap content in a page.
 * It provides a consistent padding and background, and not much else.
 * It's meant to be composed by more specific layout components.
 */
const Layout = {
  Root,
  Content,
  Logo,
  BlackLogo,
};

export default Layout;
